var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92063 0.0179971L12.3226 1.719C11.4406 2.895 10.5796 4.218 9.73963 5.688C7.97563 8.88 7.09363 12.66 7.09363 17.028H0.541625C0.667625 13.584 1.63363 10.266 3.43963 7.074C5.32963 3.798 7.15663 1.446 8.92063 0.0179971ZM20.0465 18.477L16.6445 16.776C17.5265 15.558 18.3665 14.256 19.1645 12.87C19.9205 11.61 20.5715 9.951 21.1175 7.893C21.6635 5.793 21.9365 3.672 21.9365 1.53H28.4255C28.3835 4.932 27.4175 8.271 25.5275 11.547C23.7635 14.697 21.9365 17.007 20.0465 18.477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.27fce85a752d5928c251dc15ff926ec4.svg";
export { ForwardRef as ReactComponent };